import type { CustomSurveyTemplate } from '../../api/customSurveyTemplates';

/**
 * Utility functions for CustomSurveyDashboardPage
 * Handles display logic and formatting
 */
export class CustomSurveyDashboardPageUtils {
  /**
   * Check if team selection prompt should be shown
   */
  static shouldShowTeamSelectionPrompt(selectedTeamId?: number | null): boolean {
    return !selectedTeamId;
  }

  /**
   * Check if empty state should be shown
   */
  static shouldShowEmptyState(templates?: CustomSurveyTemplate[] | null): boolean {
    return templates != null && templates.length === 0;
  }

  /**
   * Get surveys created count with fallback
   */
  static getSurveysCreatedCount(surveysCreated?: number | null): number {
    return surveysCreated ?? 0;
  }
}
